import React, { createContext, useContext, useState, useCallback } from 'react';

const AIConversationContext = createContext(undefined);

export const AIConversationProvider = ({ children }) => {
    const [messages, setMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const addMessage = useCallback((msg) => {
        setMessages(prev => [...prev, msg]);
    }, []);

    const clearMessages = useCallback(() => {
        setMessages([]);
    }, []);

    return (
        <AIConversationContext.Provider value={{
            messages,
            setMessages,
            addMessage,
            clearMessages,
            isLoading,
            setIsLoading
        }}>
            {children}
        </AIConversationContext.Provider>
    );
};

export const useAIConversation = () => {
    const context = useContext(AIConversationContext);
    if (!context) {
        throw new Error('useAIConversation must be used within an AIConversationProvider');
    }
    return context;
};
